module.exports = {"content":{},"productInfo":{"code":"{C6C03343-CA6E-4F78-AB6A-F5F79BBA830D}","name":"英語（イギリス）　初中級","serialHead":"ZTZHR","courseResourceIDs":[{"levelNo":1,"resourceID":"1c5d64f5bde0a16637f7e9583c6da149f8c967e5"},{"levelNo":2,"resourceID":"855607c38cb40fc701dd08a54e978843d17623c5"},{"levelNo":3,"resourceID":"9227d9896776488f09e2ac3c340450ef6676e19a"},{"levelNo":4,"resourceID":"2d9c0453057be752ff3b94737aa1c43a7aa8369a"},{"levelNo":5,"resourceID":"370e42bf85aa3585c8f75e747057b5f6d7fde818"}],"language":"en-GB","challengeCount":33907},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1